import { Component, ElementRef, inject, Input, Renderer2 } from '@angular/core';

@Component({
    selector: 'fourd-dropdown-toggler',
    imports: [],
    templateUrl: './dropdown-toggler.component.html',
    host: {
        'class': 'nav-link dropdown-toggle',
        '[attr.aria-haspopup]': '"true"',
        '[attr.aria-expanded]': '!isCollapsed',
        '[attr.type]': '"button"',
        '[attr.role]': '"button"',
        'tabindex': '-1', // Required for blur event to work
        '(click)': 'toggle($event)',
        '(blur)': 'close($event)',
    }
})
export class DropdownTogglerComponent {
  protected renderer = inject(Renderer2);
  protected elementRef: ElementRef<HTMLElement> = inject<ElementRef<HTMLElement>>(ElementRef);

  @Input() toggleTargetSelector: string = '.dropdown-menu';
  @Input() toggleTargetShowClass: string = 'show';
  isCollapsed: boolean = true; // Start collapsed

  toggle(event: Event): void {
    event?.stopPropagation();
    this.isCollapsed = !this.isCollapsed;
    this.refreshDisplay();
  }

  close(event: Event): void {
    event?.stopPropagation();
    this.isCollapsed = true;
    this.refreshDisplay();
  }

  private refreshDisplay(): void {
    if (this.toggleTargetSelector) {
      let targetElement = this.elementRef?.nativeElement?.parentElement?.querySelector(this.toggleTargetSelector);
      if (targetElement) {
        const targetAttributeName = 'data-bs-popper';
        if (this.isCollapsed) {
          this.renderer?.removeClass(targetElement, this.toggleTargetShowClass);
          this.renderer?.removeAttribute(targetElement, targetAttributeName);
        }
        else {
          this.renderer?.addClass(targetElement, this.toggleTargetShowClass);
          this.renderer?.setAttribute(targetElement, targetAttributeName, 'static');
        }
      }
    }
  }
}
